import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import getJob from '@/api/jobs/getJob.endpoint';

import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { JOB_STATUS } from '../constants/constants';

export default function useGetJobQuery({ jobId, refetch }) {
  const globalContext = useContext(GlobalContext);

  return useQuery({
    queryKey: [QUERY_KEYS.JOB, jobId],
    queryFn: () => getJob(jobId),
    refetchOnWindowFocus: false,
    refetchInterval: (query) =>
      refetch && query.state?.data?.status == JOB_STATUS.WORKING ? 3000 : false,
    enabled: !!jobId && !!globalContext.state.user,
    meta: {
      notification: {
        error: "We couldn't retry the sync process status. Please try again.",
      },
    },
  });
}
